import classnames from "classnames";
import React, { Fragment, useEffect, useState } from "react";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../../../api";
import {
  Dict,
  ILeadAction,
  IUpdateEventModel,
  State,
  Lead,
  LeadQuality,
} from "../../../../core";
import { colors } from "../actions/Actions";
import "react-widgets/dist/css/react-widgets.css";
import "../../../../styles/details.scss";

import { ActivityModel } from "./add-activity";
import { TimeReservationModel } from "./time-reservation-form";
import { EditEventPopup } from "./edit-event-popup";
import { useCalendarContext } from "../../../../core/hooks/useCalendarContext";
import { checkPermission } from "../../../../utils/checkPermission";
import { useSelector } from "react-redux";

interface ILeadActivityListingProps {
  leadId: string;
  initialData?: ActivityModel;
  onFormToggle: (show: boolean) => void;
  onAfterCreate: () => void;
  onChangeAssignee: (id: string) => void;
  onDatechange: (date: Date) => void;
  customerId?: string;
  lead?: Lead;
  resourceType?: string;
  loadCurrentTime?: boolean;
  isCustomerActivity?: boolean;
}

export const LeadActivityListing: React.FunctionComponent<ILeadActivityListingProps> = (
  props
) => {
  const authState = useSelector((state: State) => state.authUser);
  const leadId = props.leadId;
  const leadState = props.lead;
  const { data: leadActions } = useDataLoader<{ data: ILeadAction[] }>(() => {
    if (!leadId) {
      return [];
    }
    return api.lead.getLeadAction(leadId);
  });

  const [actions, setActions] = useState<ILeadAction[]>([]);
  const { currentActivity, onEditEvent } = useCalendarContext();

  const [_, setTimeReservationData] = useState<TimeReservationModel>();
  useEffect(() => {
    mapToTimeReservation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.initialData]);
  useEffect(() => {
    mapToTimeReservation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmitActivity = (apiModel: IUpdateEventModel) => {
    onEditEvent(currentActivity?.eventId!, apiModel, () => {
      setFormModal({});
    });
  };

  const mapToTimeReservation = () => {
    if (props.initialData) {
      const data = props.initialData;
      const reservation: TimeReservationModel = {
        timePeriod: data.timePeriod,
        salesPerson: data.salesPerson,
      };
      setTimeReservationData(reservation);
    }
  };

  const isSalespersonAssigned = true;
  const [formModal, setFormModal] = React.useState<Dict>({});

  useEffect(() => {
    // const tempActions =
    //   leadActions?.data?.filter((p) => includeList.indexOf(p.code) !== -1) ??
    //   [];
    const tempActions = []

    const otherAction: ILeadAction = {
      name: "Create Activity",
      code: "call",
      _id: "call",
    };
    if (props.leadId || props.customerId) {
      tempActions.push(otherAction);
    }
    const timeReservation: ILeadAction = {
      name: "Time Reservation",
      code: "timeOff",
      _id: "timeOff",
    };
    const vehicleTimeReservation: ILeadAction = {
      name: "Vehicle Time Reservation",
      code: "vehicleTimeOff",
      _id: "vehicleTimeOff",
    };
    if (props.resourceType === "staff") {
      // tempActions.push(timeReservation);
    }
    if (props.resourceType === "vehicle") {
      // tempActions.push(vehicleTimeReservation);
    }

    setActions(tempActions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadActions]);

  useEffect(() => {
    if (Object.keys(formModal).length > 0) {
      props.onFormToggle(true);
    } else {
      props.onFormToggle(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formModal]);

  const includeList = [
    "scheduleATestDrive",
    "scheduleAShowroomVisit",
    "requestACallBack",
    "call",
    "timeOff",
    "vehicleTimeOff",
  ];

  return (
    <Fragment>
      <div style={{ marginTop: 10 }} className="col-md col-12 accordion p-0">
        <div id="Actions" className="accordion__panel accordion__panel--open">
          <div className="accordion__body">
            <div className="tabButtonContent">
              <div className="tabButtonContent__item tabButtonContent__item--active">
                <div className="accordion accordion--sm">
                  {actions.map((action) => {
                    return checkPermission(
                      action.code,
                      authState.apiPermissions
                    ) ? (
                      <div className="accordion__panel accordion__panel--open">
                        <div
                          onClick={() => {
                            
                            if (
                              action?.code !== "call" &&
                              (props.lead && !(props.lead?.quality === LeadQuality.Interested))
                            ) {
                              return;
                            }

                            if (formModal[action.code]) {
                              setFormModal({});
                            } else {
                              setFormModal({
                                [action.code]: !formModal[action.code],
                              });
                            }
                          }}
                          className={classnames({
                            "accordion__head border d-flex align-items-center rounded cursor-pointer mb-2": true,
                            "bg-gray-100":
                              action?.code !== "call" &&
                              (!isSalespersonAssigned ||
                              (props.lead && !(props.lead?.quality === LeadQuality.Interested))),
                          })}
                        >
                          <div
                            className={classnames({
                              "rounded text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2": true,
                              "bg-gray-300":
                                action?.code !== "call" ||
                                !isSalespersonAssigned ||
                                (props.lead && !(props.lead?.quality === LeadQuality.Interested)),
                              [colors[action.code]]:
                                action?.code === "call" ||
                                (isSalespersonAssigned &&
                                  (!props.lead || props.lead?.quality === LeadQuality.Interested)),
                            })}
                          >
                            <i className="icon-chevron-right"></i>
                          </div>
                          <div className="font-sm font-weight-semibold text-gray-700 pl-1">
                            {action.name}
                          </div>
                        </div>
                        {formModal[action.code] && isSalespersonAssigned && (
                          <EditEventPopup
                            customerId={props.customerId}
                            action={action}
                            isEdit={false}
                            currentActivity={
                              props.initialData !== undefined
                                ? { ...props.initialData, type: action.code, salesPerson: props?.initialData?.salesPerson,
                                company : leadState?.company }
                                : undefined
                            }
                            onClose={() => {
                              setFormModal({});
                            }}
                            onSubmit={(updatedEvent) => {
                              onSubmitActivity(updatedEvent);
                            }}
                            leadId={leadId}
                            loadCurrentTime={props?.loadCurrentTime}
                            isCustomerActivity={props?.isCustomerActivity}
                          ></EditEventPopup>
                        )}
                      </div>
                    ) : (
                      <></>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export interface ILeadEventInitData {
  date: Date;
  startTime: string;
  endTime: string;
}
